<template>
  <div class="fund-transfer"
       ref="transfer">
    <bCardHeader :param="param"
                 class="card-header"></bCardHeader>
    <el-row :gutter="30"
            class="m0">
      <el-col :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
              class="p0">
        <div v-loading="formLoading"
             element-loading-text="加载中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.3)"
             class="card-base card-shadow--small fund-transfer-form">
          <h1 class="h1-title">{{$t('transfer.fund_transefer')}}</h1>
          <el-form ref="form"
                   :model="form"
                   :rules="rules"
                   label-position="top">
            <!--账号选择-->
            <el-form-item :label="$t('transfer.from_account')"
                          prop="outAccount">
              <bAccountNumbersSelect v-model="form.outAccount"
                                     @change="changeOutAccountFn"></bAccountNumbersSelect>
              <!-- <el-select v-model="form.outAccount" :placeholder="$t('common.please_select')" @change="changeOutAccountFn($event)">
                <el-option v-for="(item, index) in fromAccountArr" :key="index" :label="getKey(item.type) + (item.type === 'FOREX' && item.tradeAccountType?getKey(item.tradeAccountType):'') +$t('common.ACCOUNT') + item.tradeAccount " :value="item.tradeAccount"></el-option>
              </el-select> -->
            </el-form-item>
            <!-- <el-form-item :label="$t('transfer.to_currency')" prop="out_currency">
              <el-select v-model="currencyOption" :placeholder="$t('common.please_select')" @change="selectCurrency($event)">
                <el-option v-for="(item, index) in outCurrencyList" :key="index"
                  :label="item.currency + ' | ' + currencyOptionText[item.currency]"
                  :value="item.currency"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <!--收款账户-->
            <el-form-item :label="$t('transfer.to_account')"
                          prop="inAccount">
              <el-select v-model="form.inAccount"
                         :placeholder="$t('common.please_select')"
                         @change="changeInAccountFn($event)">
                <el-option v-for="(item, index) in toAccountArr"
                           :key="index"
                           :label="item.label+' | '+item.tradeAccount"
                           :value="item.tradeAccount"
                           :disabled="item.disabled">
                </el-option>
              </el-select>
            </el-form-item>
            <!--可转账额度-->
            <!--      <el-form-item v-if = "showBalance" :label="$t('transfer.balance')" class="readonly-input">
              <el-input :disabled="true" v-model="outRequestAmount" readonly step="0.01" class="input_aomut">
                <template slot="prepend">
                  {{outCurrency}} -->
            <!-- <el-select class="currency-input" v-model="outCurrency" @change="selectCurrency" :placeholder="$t('common.please_select')">
                    <el-option v-for="(item,index) in outCurrencyList" :key="index"  :value="item" :label="item"></el-option>
                  </el-select> -->
            <!-- </template>
                <div disabled="disabled"  slot="prefix" class="money-icon">{{outCurrencyIocn}}</div>
              </el-input>
            </el-form-item> -->
            <el-form-item v-if="showBalance && this.outType !== 'MT5'"
                          :label="$t('transfer.balance')"
                          class="readonly-input">
              <el-input placeholder=""
                        readonly
                        :disabled="true"
                        class="input_aomut">
                <template slot="prepend">HKD</template>
                <div slot="prefix"
                     class="money-icon">${{formatHKDBalance}}</div>
              </el-input>
              <el-input placeholder=""
                        readonly
                        :disabled="true"
                        class="input_aomut line-space-input">
                <template slot="prepend">USD</template>
                <div slot="prefix"
                     class="money-icon">${{formatUSDBalance}}</div>
              </el-input>
              <el-input placeholder=""
                        readonly
                        :disabled="true"
                        class="input_aomut line-space-input">
                <template slot="prepend">CNY</template>
                <div slot="prefix"
                     class="money-icon">¥{{formatCNYBalance}}</div>
              </el-input>
            </el-form-item>
            <el-form-item v-if="showBalance && this.outType === 'MT5'"
                          class="readonly-input"
                          label-suffix="rty">
                          <label>
                            <span>{{$t('transfer.acceptableAmount')}}</span>
                            <img @click="helpDialog=true"
                              class="help-box"
                              src="@/assets/images/help.png"
                              alt="">
                          </label>

              <el-input placeholder=""
                        readonly
                        :disabled="true"
                        class="input_aomut">
                <template slot="prepend">USD</template>
                <div slot="prefix"
                     class="money-icon">${{formatUSDBalance}}</div>
              </el-input>
            </el-form-item>
            <!--转账金额-->
            <el-form-item :label="$t('transfer.transefer_amount')"
                          prop="outAmount"
                          ref="outAmount">
              <el-input v-model="form.outAmount"
                        type="number"
                        step="0.01"
                        min="5.00"
                        class="input_aomut"
                        :placeholder="placeholderText">
                <template slot="prepend">
                  <span v-if="isShowOutCurrencySpan">{{outCurrency}}</span>
                  <el-select v-else
                             class="currency-input"
                             v-model="outCurrency"
                             :placeholder="$t('common.please_select')"
                             @change="selectOutCurrency(outCurrency)">
                    <el-option v-for="(item,index) in outCurrencyList"
                               :key="index"
                               :value="item"
                               :label="item"></el-option>
                  </el-select>
                </template>
                <div slot="prefix"
                     class="money-icon">$</div>
              </el-input>
            </el-form-item>
             <el-form-item>
              <div class="depositReciepTips transfer-tip">
                <p v-html="$t('transfer.transferInterTip')"></p>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="depositReciepTips">
                <u class="ReciepTipsTitle">{{$t('fundTransfer.fundTransferTipsTitle')}}</u>
                <p>
                  <u>{{$t('fundTransfer.fundTransferTips.exchangePriceDifferenceCompany.title')}}</u>
                </p>
                <p>
                  {{$t('fundTransfer.fundTransferTips.exchangePriceDifferenceCompany.tips')}}
                </p>
              </div>
            </el-form-item>
            <el-form-item prop='checked'>
              <el-checkbox class="checkboxTips"
                           v-model="checked">{{$t('fundTransfer.haveRead')}}</el-checkbox>
            </el-form-item>
            <el-form-item class="text-center">
              <el-button type="primary"
                         class="el-button-sub"
                         :loading="subLoading"
                         :disabled="disabledSubmit"
                         @click="submitFn('form')">{{$t('common.submit')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>

      <el-col :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
              class="p0 transfer-records">
        <bThreeList @cencelFun="cencelFun"
                    type="transfer"
                    :params="parentList"
                    :src='src'
                    :text="$t('transfer.noFund')"
                    :router="router"></bThreeList>
      </el-col>
    </el-row>
    <!-- 撤销弹窗 -->
    <bCancelDialog :dialogVisible.sync="IsCancelShow"
                   type="transfer"
                   :closeModal="closeModal"
                   :loading.sync="loadingSub"
                   :handle="cancelFundTransfer"></bCancelDialog>
    <!-- 表单需要提交参数预览弹窗 -->
    <bPreviewDialog :dialogVisible.sync="IsPreviewShow"
                    type="attention"
                    :closeModal="closeModal"
                    :loading.sync="loadingSub"
                    :params="previewData"
                    :handle="createFundTransfer"
                    :sellRate="sellRate"
                    :currency="outCurrency"
                    :specialsubTip="subTip"
                    @closeHandle="isChecked=false">
      <!-- 强制平仓提示 -->
      <!-- <template v-if="isNeedPoint">
          <div class="liquidation-box">{{$t('withdrawal.liquidation')}}</div>
          <div class="check-box">
            <el-checkbox class="checkboxTips"
                     v-model="isChecked">{{$t('withdrawal.konwtext')}}</el-checkbox>
          </div>
        </template> -->
      <!-- 外汇平仓提示 -->
      <template v-if="this.outType==='MT5'">
        <div class="check-box">
          <el-checkbox class="checkboxTips"
                       v-model="isChecked">{{$t('withdrawal.konwtext')}}</el-checkbox>
        </div>
      </template>
    </bPreviewDialog>
    <!-- 获取申请码弹窗 -->
    <bDialog :dialogVisible.sync="IsCodeShow"
             @closeChange="closeChange"
             :refresh="refresh"
             :params="dialogParams"
             :closeModal="closeModal"
             :component="componentDialog"
             :contiune="contiune"
             :showClose="showClose"></bDialog>
    <!-- 建议最大可提金额解释 -->
    <el-dialog :title="$t('transfer.acceptableAmount')"
               class="transfer-help-dialog"
               :visible.sync="helpDialog"
               width="30%"
               :before-close="handleClose">
      <p>{{$t('transfer.largestAmount')}}</p>
    </el-dialog>
    <el-dialog class="error-dialog"
                  :visible.sync="spdialogOpen"
                  :title="$t('logout.tips')"
                  width="30%">
                  <div>{{$t('common.spInfo')}}</div>
                  <div slot="footer" class="footer-box">
                    <el-button style="width:40%;margin-left:0;" type="primary" @click="spdialogOpen=false">{{$t('common.ok')}}</el-button>
                  </div>
     </el-dialog>
     <el-dialog
                :visible.sync="popupVisible"
                width="30%"
                class="fund-box"
                :before-close="toContinue"
                :close-on-click-modal="false">
      {{$t('common.dormantDetailTip')}}
      <div class="btn-box btn-box-one">
        <div class="top"
              @click="toContinue">{{$t('common.knowIt')}}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import complete from './info-dialog'
import { mapGetters, mapState } from 'vuex'
import api from '@/api/v2/transfer'
import api1 from '@/api/v2/trade'
import api2 from '@/api/v2/withdrawal'
import _ from 'lodash'
import exchangeRateApi from '@/api/v2/exchangeRate'
import moment from 'moment'
export default {
  name: 'fund-transfer',
  data () {
    var validateOutCurrency = (rule, value, callback) => {
      if (!this.currencyOption) {
        return callback(new Error(this.$t('common.please_select_currency')))
      } else {
        callback()
      }
    }
    var validateOutAmount = (rule, value, callback) => {
      if (!this.outCurrency) {
        return callback(new Error(this.$t('common.please_select_currency')))
      }
      var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      if (value === '') {
        return callback(new Error(this.$t('common.please_input')))
      } else if (isNaN(Number(this.outRequestAmount))) {
        return callback(new Error(this.$t('transfer.balanceLow')))
      } else if (this.showBalance && this.outType === 'MT5' && Number(this.mt5Amount) < Number(this.form.outAmount)) {
        return callback(new Error(this.$t('transfer.validate.maxMt5')))
      } else if (this.showBalance && this.outType !== 'MT5' && Number(this.totalAmount) < Number(this.form.outAmount)) {
        return callback(new Error(this.$t('transfer.validate.max') + this.outCurrency + this.Util.formatCurrency(this.totalAmount)))
      } else if (this.form.outAmount < 0.01) {
        return callback(new Error(this.$t('transfer.validate.min')))
      } else if (!reg.test(value)) {
        return callback(new Error(this.$t('withdrawal.error_withdrawal_amount_3')))
      } else {
        return callback()
      }
    }
    // var validateInCurrency = (rule, value, callback) => {
    //   return callback()
    // }
    var checkedVal = (rule, value, callback) => {
      console.log(rule, value)
      var f = rule.field
      if (!this[f]) {
        return callback(new Error(this.$t('applyTradeAccount.checked')))
      }
      callback()
    }
    let checkOutTradeAccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('withdrawal.error_account_number')))
      }
      callback()
    }
    return {
      text: 'noFund',
      router: 'transfer',
      src: require('@/assets/images/noFundertransfer.png'),
      param: {
        title: 'transferTitle',
        links: [{ title: 'home' }, { title: 'transferTitle' }]
      },
      cancelOrderId: '',
      value6: undefined,
      disabledSubmit: false,
      loadingSub: false,
      availableFundShow: true,
      parentList: [],
      listTitle: 'FUND TRANSFER',
      IsPreviewShow: false, // 是否打开预览
      IsCancelShow: false,
      showClose: false, // 申请码关闭小图标
      contiune: true, // 申请码继续按钮
      IsCodeShow: false, // 是否打开申请码弹窗
      componentDialog: complete, // 申请码弹窗内容
      checked: false,
      fromAccountArr: [],
      toAccountArr: [],
      oldListData: [],
      outCurrency: 'HKD',
      currencyOption: '', // 选择币种
      currencyOptionText: {
        'HKD': this.$t('common.hkd'),
        'USD': this.$t('common.usd'),
        'CNY': this.$t('common.cny')
      },
      outCurrencyIocn: '',
      outRequestAmount: '', // 可转账额度
      outCurrencyList: ['HKD', 'USD', 'CNY'],
      outCurrencyIocnList: [],
      inCurrency: 'HKD',
      inCurrencyIocn: '',
      inCurrencyList: [],
      inCurrenyIocnList: [],
      orderId: '',
      accountNumber: '',
      cashList: [],
      accountId: '',
      showBalance: true,
      form: {
        outAccount: '',
        inAccount: '',
        outAmount: ''
      },
      outType: '',
      outAccountType: '',
      outAccountInfo: {},
      outTradeAccountType: '',
      inType: '',
      inAccountType: '',
      inAccountInfo: {},
      inTradeAccountType: '',
      closeModal: false,
      rules: {
        checked: [
          {
            validator: checkedVal
          }
        ],
        outAccount: [
          {
            required: true,
            validator: checkOutTradeAccount,
            trigger: 'change'
          }
        ],
        inAccount: [
          {
            required: true,
            message: this.$t('common.please_select'),
            trigger: 'change'
          }
        ],
        outAmount: [
          {
            required: true,
            validator: validateOutAmount,
            trigger: 'change'
          }
        ],
        out_currency: [
          {
            required: true,
            validator: validateOutCurrency,
            trigger: 'change'
          }
        ]
      },
      subLoading: false,
      outTradeAccountSelect: [],
      formLoading: false,
      helpDialog: false,
      mt5Amount: 0,
      feeInfo: {},
      type: 'STOCK',
      previewData: {},
      sellRate: {},
      subTip: '',
      isNeedPoint: false,
      isChecked: false,
      placeholderText: this.$t('fundTransfer.placeholderAmount'),
      totalAmount: 0,
      spdialogOpen: false,
      isDormant: false,
      popupVisible: false
    }
  },
  computed: {
    ...mapGetters(['getUser', 'getAccountTypeObj', 'getTransferAccountInfos', 'valueAccountNumber', 'getClientProfile', 'getAccountInfo']),
    ...mapState(['filterSPTradingAccountList', 'userInfo']),
    tradeAccountList () {
      return this.getAccountInfo
    },
    firstName () {
      return this.getClientProfile && this.getClientProfile.userInfo ? this.getClientProfile.userInfo.firstName : ''
    },
    lastName () {
      return this.getClientProfile && this.getClientProfile.userInfo ? this.getClientProfile.userInfo.lastName : ''
    },
    dialogParams () {
      return { orderId: this.orderId }
    },
    HKDBalance () {
      if (!this.cashList.length) return 0
      if (!this.cashList.find(item => item.currency === 'HKD')) return 0
      return this.cashList.find(item => item.currency === 'HKD').amount
    },
    USDBalance () {
      if (!this.cashList.length) return 0
      if (!this.cashList.find(item => item.currency === 'USD')) return 0
      if (this.outType !== 'MT5') {
        return this.cashList.find(item => item.currency === 'USD').amount
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.mt5Amount = this.cashList.find(item => item.currency === 'USD').amount
        return this.cashList.find(item => item.currency === 'USD').maxAmount
      }
      // return this.cashList.find(item => item.currency === 'USD').amount
    },
    CNYBalance () {
      if (!this.cashList.length) return 0
      if (this.outTradeAccountType === 'futuresMargin') {
        if (!this.cashList.find(item => item.currency === 'CNH')) return 0
        return this.cashList.find(item => item.currency === 'CNH').amount
      } else {
        if (!this.cashList.find(item => item.currency === 'CNY')) return 0
        return this.cashList.find(item => item.currency === 'CNY').amount
      }
    },
    formatHKDBalance () {
      return (this.HKDBalance.toFixed(2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    },
    formatUSDBalance () {
      return (this.USDBalance.toFixed(2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    },
    formatCNYBalance () {
      return (this.CNYBalance.toFixed(2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    },
    isShowOutCurrencySpan () {
      return ['mf', 'mt5', 'bullionMargin'].includes(this.outTradeAccountType) || this.inType === 'MT5'
    }
  },
  created () {
    // 仅有sp账户
    if (this.userInfo.isSPAccount === 'Y' && !this.filterSPTradingAccountList.length) {
      return (this.spdialogOpen = true)
    }
    this.initOutTradeAccountSelect()
  },
  mounted () {
    // let arr = _.cloneDeep(this.tradeAccountList)
    // this.initFromAccountArr(this.tradeAccountList)
    // this.setDatas(arr)
    this.refresh()
    this.getExchangeRate()
    this.getTransferRecords()
  },
  watch: {
    isShowOutCurrencySpan (val, oldVal) {
      if (val) {
        this.outCurrency = 'USD'
      }
    }
  },
  methods: {
    // 获取awb值
    getTotalAmount () {
      let params = {
        currency: this.outCurrency,
        type: this.outType,
        tradeAccountNumber: this.form.outAccount
      }
      console.log(this.outCurrency, 'this.outCurrency')
      if (['STOCK', 'FUTURES', 'FUND'].includes(this.type)) {
        api1.getTotalAmount(params).then(res => {
          let data = res.data ? res.data : {}
          this.totalAmount = data.amount ? data.amount : 0
          this.placeholderText = `${this.$t('fundTransfer.placeholderAmount')},${this.$t('fundTransfer.maxText')}${this.outCurrency} ${this.Util.formatCurrency(this.totalAmount)}`
          if (this.form.outAmount) {
            this.$refs['outAmount'].onFieldChange()
          }
        })
      } else {
        this.placeholderText = this.$t('fundTransfer.placeholderAmount')
      }
    },
    isNeedPointFun (val) {
      this.isNeedPoint = val
    },
    translateString (val, money) {
      let tipString = ''
      if (val && val.includes('{}')) {
        tipString = val.replace('{}', money)
      }
      return tipString
    },
    async getExchangeRate () {
      let res = await exchangeRateApi.getExchangeRate()
      this.sellRate = (res && res.data) || {}
    },
    tradeAccountConfig (tradeAccountType) {
      return this.Util.getTradeAccountConfig(tradeAccountType)
    },
    async getActiveManageFee () {
      let params = {
        currency: this.outCurrency,
        type: this.type,
        tradeAccountNumber: this.form.outAccount,
        feeType: 'TRANSFER',
        amount: this.form.outAmount
      }
      let res = await api2.getActiveManageFee(params)
      if (res && res.code === 200) {
        this.feeInfo = res.data ? res.data : {}
        // this.feeInfo = {
        //   activeManageFee: 100,
        //   currency: 'HKD',
        //   financeCurrency: 'HKD',
        //   financeFee: 1500,
        //   isNeedFee: true,
        //   isNeedFeeFinance: true
        // }
      } else {
        this.feeInfo = {}
      }
    },
    initOutTradeAccountSelect () {
      try {
        let tradeAccountList = []
        // let accountId = this.getAccountInfo._id
        if (this.userInfo.isSPAccount === 'Y') {
          tradeAccountList = this.filterSPTradingAccountList.filter(item => item.status !== 'CLOSE')
        } else {
          tradeAccountList = this.getAccountInfo.filter(item => item.enabled !== 'CLOSE')
        }
        let arr = []
        tradeAccountList.forEach(item => {
          // let tradeAccountConfig = this.tradeAccountConfig(item.tradeAccountType)
          let obj = {}
          obj.label = this.$t(`tradeAccountType.${item.tradeAccountType}`)
          obj.type = item.type
          obj.value = item.tradeAccountNumber
          // obj.accountId = accountId
          obj.accountType = item.accountType
          obj.tradeAccountType = item.tradeAccountType.toLowerCase().replace(/_[a-z]/g, function (m) {
            return m.slice(1).toUpperCase()
          })
          item._tradeAccountType = item.tradeAccountType.toLowerCase().replace(/_[a-z]/g, function (m) {
            return m.slice(1).toUpperCase()
          })
          obj._tradeAccountType = item.tradeAccountType
          obj.disabled = false
          let enabled = true
          // 如果账户是开启(open和true两种状态)和允许做换汇的才显示
          switch (item.status) {
            case 'OPEN':
              enabled = true
              break
            case 'STOP':
              enabled = false
              break
            default:
              enabled = false
              break
          }
          // if (!enabled || !tradeAccountConfig['isShowTransfer']) {
          //   obj.disabled = true
          // }
          if (!enabled) {
            obj.disabled = true
          }
          arr.push(obj)
        })
        this.outTradeAccountSelect = arr
        console.log(this.outTradeAccountSelect, 'this.outTradeAccountSelect')
      } catch (error) {
        console.log('>>>>error', error)
        let message = this.$t('exchange.errMsg.10002')
        this.$message({
          showClose: true,
          message: message,
          type: 'error'
        })
      }
    },
    cancelFundTransfer () {
      // let obj = _.find(this.oldListData, { orderId: this.cancelOrderId })
      // let id = obj._id
      let options = {
        orderId: this.cancelOrderId
      }
      this.loadingSub = true
      api.cancelTransfer(options).then(result => {
        console.log(result)
        this.IsCancelShow = false
        this.loadingSub = false
        this.openMessage('success', this.$t('common.cencel_dialog.cancel.transfer'))
        setTimeout(() => {
          // this.refresh()
          this.getTransferRecords()
        }, 600)
      }).catch(err => {
        this.loadingSub = false
        console.log(err)
        if (err.code === '510') {
          this.$message.error(this.$t('common.noCancel'))
        }
      })
    },
    cencelFun (val) {
      console.log('----->', val)
      this.cancelOrderId = val
      this.IsCancelShow = true
    },
    initToAccountArr (tradeAccounNumber) {
      let tradeAccountList = []
      if (this.userInfo.isSPAccount === 'Y') {
          tradeAccountList = this.filterSPTradingAccountList.filter(item => item.status !== 'CLOSE')
        } else {
          tradeAccountList = this.tradeAccountList.filter(item => item.enabled !== 'CLOSE')
        }
      this.form.inAccount = ''
      // let tradeAccountList = this.tradeAccountList.filter(item => item.status !== 'CLOSE')
      let tradeAccountListTemp = _.cloneDeep(tradeAccountList)
      let toAccountArr = []
      tradeAccountListTemp.map(item => {
        let obj = {}
        obj['type'] = item.type
        // obj['accountType'] = item.accountType
        obj['tradeAccountType'] = item.tradeAccountType
        obj._tradeAccountType = item._tradeAccountType
        obj['enabled'] = item.status
        obj['status'] = item.status
        obj['isDormant'] = item.isDormant
        obj['tradeAccount'] = item.tradeAccountNumber
        obj['disabled'] = false
        let tradeAccountTypeObjConfig = this.tradeAccountConfig(item._tradeAccountType) || {}
        obj['label'] = this.$t(`tradeAccountType.${item.tradeAccountType}`)

        let flag = !(item.status === 'OPEN' || item.status === true)
        if (item.tradeAccountNumber === tradeAccounNumber) {
          obj['disabled'] = true
        }
        if (flag || !tradeAccountTypeObjConfig['isShowTransfer']) {
          obj['disabled'] = true
        }
        if (obj.tradeAccountType !== 'VA') {
          toAccountArr.push(obj)
        }
      })
      this.toAccountArr = toAccountArr
      console.log(toAccountArr, 'toAccountArr')
    },
    async changeOutAccountFn (tradeAccountObj) {
      this.outAccountInfo = tradeAccountObj
      try {
        this.formLoading = true
        // 清空余额
        this.cashList = []
        this.form.outAmount = ''
        let tradeAccounNumber = tradeAccountObj.value
        this.form.outAccount = tradeAccounNumber
        this.type = tradeAccountObj.type
        // this.initFromAccountArr(this.tradeAccountList)
        this.initToAccountArr(tradeAccounNumber)
        let tradeAccountType = tradeAccountObj.tradeAccountType
        console.log('type>>>>', tradeAccountObj)
        this.outType = tradeAccountObj._tradeAccountType
        this.outAccountType = tradeAccountObj.accountType
        this.outTradeAccountType = tradeAccountType
        // this.outCurrency = this.tradeAccountConfig(this.outTradeAccountType)['currency']['value']
        // if (['mf', 'mt5', 'bullionMargin'].includes(this.outTradeAccountType)) {
        //   this.inCurrency = 'USD'
        // } else {
        //   this.inCurrency = 'HKD'
        // }
        if (!this.tradeAccountConfig(tradeAccountType)['isTradeAccountExit']) {
          // eslint-disable-next-line no-throw-literal
          throw { code: '5003', msg: 'tradeAccountType is lost' }
        }
        this.showBalance = this.tradeAccountConfig(tradeAccountType)['showBalance']
        if (this.showBalance && tradeAccountObj.type !== 'STOCK' && tradeAccountObj.type !== 'FUND') {
          // 获取余额
          let res = await this.getTradeAccountBalance(tradeAccounNumber, tradeAccountObj._tradeAccountType)
          this.formLoading = false
          this.cashList = res.data
          if (!res.data) {
            let message = this.$t(`errMessage.11000`)
            this.$message({
              showClose: true,
              message: message,
              type: 'error'
            })
          }
          this.getTotalAmount()
        } else {
          this.getNewBalance(tradeAccountObj)
        }
        if (this.form.outAmount) {
          this.$refs['outAmount'].onFieldChange()
        }
      } catch (error) {
        this.formLoading = false
        console.log('>>>>error', error)
        let message = this.$t(`errMessage.11000`)
        this.$message({
          showClose: true,
          message: message,
          type: 'error'
        })
      }
    },
    async changeInAccountFn (tradeAccounNumber) {
      try {
        let tradeAccount = this.toAccountArr.find((obj) => {
          return obj.tradeAccount === tradeAccounNumber
        })
        this.inAccountInfo = tradeAccount
        // let tradeAccountType = tradeAccount.tradeAccountType
        if (!this.tradeAccountConfig(tradeAccount._tradeAccountType)['isTradeAccountExit']) {
          // eslint-disable-next-line no-throw-literal
          throw { code: '5003', msg: 'tradeAccountType is lost' }
        }
        this.inType = tradeAccount.tradeAccountType
        this.inAccountType = tradeAccount.accountType
        this.inTradeAccountType = tradeAccount._tradeAccountType
        if (tradeAccount.type === 'FOREX' || this.type === 'FOREX') {
          this.outCurrency = 'USD'
        } else {
          this.outCurrency = 'HKD'
        }
        this.form.outAmount = ''
        if (this.type !== 'STOCK' && this.type !== 'FUND') {
          this.getTotalAmount()
        } else {
          this.totalAmount = this.cashList.find(item => item.currency === this.outCurrency).maxAmount || 0
          this.placeholderText = `${this.$t('fundTransfer.placeholderAmount')},${this.$t('fundTransfer.maxText')}${this.outCurrency} ${this.Util.formatCurrency(this.totalAmount)}`
        }
      } catch (error) {
        console.log('>>>>error', error)
        let message = this.$t(`errMessage.${error.code}`)
        this.$message({
          showClose: true,
          message: message,
          type: 'error'
        })
      }
    },
    async groupByCurrency (tradeAccount) {
      // 入金成功的货币就是出金可以选择的货币
      let option = {}
      let tempCurrencys = []
      option.groupBy = '$exchangedCurrency'
      option['tradeAccount'] = tradeAccount
      option['status'] = 'completed'
      option.viewType = 'deposit'
      const result = await this.$api.groupByCurrency(option)
      if (result.code === 200) {
        result.data.map(item => {
          tempCurrencys.push(item._id)
        })
      }
      return tempCurrencys
    },
    getKey (key) {
      let item = this.$t('common')
      return item[key] ? item[key] : key
    },
    initTreeList (data) {
      this.oldListData = data
      this.parentList = []
      data.forEach(element => {
        let item = {}
        item.applyTime = moment(element.createdDate).format('YYYY-MM-DD HH:mm:ss')
        item.status = element.status
        item.orderId = element.orderId
        item.childList = {
          fromAccount: element.fromTradeAccountNumber,
          toAccount: element.toTradeAccountNumber,
          outAmount:
            element.fromCurrency +
            ' ' +
            this.Util.formatCurrency(element.fromAmount),
          applyTime: moment(element.createdDate).format('YYYY-MM-DD HH:mm:ss')
        }
        if (item.status === 'FAILURE') {
          Object.assign(item.childList, { remark: element.remark })
        }
        this.parentList.push(item)
      })
      this.parentList = this.parentList.slice(0, 3)
    },
    submitFn (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.subLoading = true
          this.subLoading = false
          this.previewData = {
            ...this.form
          }
          await this.getActiveManageFee()
          // 有一手融手续费
          if (this.feeInfo && this.feeInfo.isNeedFeeFinance) {
            this.previewData.financeFee = this.feeInfo.financeFee
            this.previewData.actualtransferAmount = (this.form.outAmount - this.feeInfo.financeFee) >= 0
              ? (Math.round(this.form.outAmount * 100) - Math.round(this.feeInfo.financeFee * 100)) / 100 : 0
            this.subTip = this.translateString(this.$t(`common.preview_dialog.transferfinanceTip`), `${this.outCurrency}${this.Util.formatCurrency(this.feeInfo.financeFee)}`)
          } else {
            delete this.previewData.financeFee
            delete this.previewData.actualtransferAmount
            this.subTip = this.$t(`common.preview_dialog.transferTip`)
          }
          // if (this.type === 'FOREX') {
          //   if (Number(this.USDBalance) < Number(this.form.outAmount) && Number(this.form.outAmount) <= Number(this.mt5Amount)) {
          //     this.isNeedPoint = true
          //   } else {
          //     this.isNeedPoint = false
          //   }
          // } else {
          //   this.isNeedPoint = false
          // }
          if (this.outAccountInfo.isDormant || this.inAccountInfo.isDormant) {
            this.popupVisible = true
            return
          }
          this.IsPreviewShow = true
        } else {
          return false
        }
      })
    },
    toContinue() {
      this.popupVisible = false
      this.IsPreviewShow = true
    },
    refresh () {
      // Promise.all([
      //   api.getTransferRecords()
      // ]).then(result => {
      this.$refs['form'].resetFields()
      this.$set(this.form, 'outAccount', null)
      // console.log(this.form.outAccount, 'form.outAccountform.outAccount')
      delete this.form['checked']
      this.getTransferRecords()
      this.accountId = this.getAccountInfo._id
      // })
    },
    async getTransferRecords () {
      let res = await api.getTransferRecords()
      if (res && res.code === 200) {
        this.initTreeList(res.data ? res.data : [])
      }
    },
    confirm () {
      this.$confirm(this.$t('transfer.success'), '提示', {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        this.createFundTransfer()
      }).catch(() => {
        // this.closeModal = true;
        // this.IsPreviewShow = false;
        // this.loadingSub = false;
      })
    },
    closeChange () {
      this.openMessage('success', this.$t('transfer.success'))
      window.location.reload()
    },
    createFundTransfer () {
      try {
        if (this.outType === 'MT5' && !this.isChecked) {
          this.$message.error(this.$t('withdrawal.checkInfo'))
          return
        }
        if (this.form.outAccount === this.form.inAccount) {
          return this.openMessage('success', this.$t('transfer.sameOutAndIn'))
        }
        let isError = false
        if (!this.tradeAccountConfig(this.outTradeAccountType)['isTradeAccountExit']) {
          isError = true
        }
        if (!this.tradeAccountConfig(this.inTradeAccountType)['isTradeAccountExit']) {
          isError = true
        }
        if (isError) {
          // eslint-disable-next-line no-throw-literal
          throw { code: '5003', msg: 'tradeAccountType is lost' }
        }
        this.loadingSub = true
        let formData = {}
        this.closeModal = false
        formData.fromTradeAccountNumber = this.form.outAccount // 转出账户
        formData.fromAmount = parseFloat(this.form.outAmount) // 转出金额
        formData.fromCurrency = this.outCurrency // 交易账号类型(转出)
        formData.fromTradeAccountType = this.outType // 交易账号类型
        formData.submitSource = 'CP_WEB' // 提交来源
        formData.toTradeAccountNumber = this.form.inAccount // 转入账户
        formData.toTradeAccountType = this.inType // 交易账号类型(转入)
        api
          .commitTransfer(formData)
          .then(result => {
            this.orderId = result.data.orderId
            this.IsPreviewShow = false
            this.IsCodeShow = true // 提交之后返回
            this.loadingSub = false
            this.checked = false
          })
          .catch(error => {
            console.log(error)
            this.closeModal = true
            this.loadingSub = false
            // if (error.code === 6200) {
            //   return this.openMessage(
            //     'warning',
            //     this.$t('withdrawal.error_withdrawal_check')
            //   )
            // }
            // this.$message.error(error.msg)
          })
      } catch (error) {
        console.log('>>>>>error', error)
        this.closeModal = true
        this.loadingSub = false
        // if (error.code) {
        //   let message = this.$t(`errMessage.${error.code}`)
        //   this.$message({
        //     showClose: true,
        //     message: message,
        //     type: 'error'
        //   })
        // } else {
        //   this.$message.error(this.$t('withdrawal.error_submit'))
        // }
      }
    },
    async getTradeAccountBalance (val, tradeAccountType) {
      try {
        const result = await api1.getUserBalance({
          tradeAccountNumber: val,
          tradeAccountType
        })
        return result
      } catch (error) {
        console.log('>>>>>>获取交易账户余额异常', error)
        // let accountInfo = this.$t(`tradeAccountType.${tradeAccountType}`) + val
        // let errorMessage = accountInfo + this.$t(`errMessage.${error.code}`)
        // this.$message.error(errorMessage)
      }
    },
    selectOutCurrency (val) {
      console.log(this.outType, 'this.outType')
      this.outCurrencyIocn = this.$getCurrencyIocn()[val]
      if (this.outCurrency && this.outType && this.form.outAccount) {
        if (this.type !== 'STOCK' && this.type !== 'FUND') {
          this.getTotalAmount()
        } else {
          this.totalAmount = this.cashList.find(item => item.currency === this.outCurrency).maxAmount || 0
          this.placeholderText = `${this.$t('fundTransfer.placeholderAmount')},${this.$t('fundTransfer.maxText')}${this.outCurrency} ${this.Util.formatCurrency(this.totalAmount)}`
        }
      }
    },
    handleClose () {
      this.helpDialog = false
    },
    // 获取证券余额
    async getNewBalance(val) {
      let params = {
        tradeAccount: val.value,
        accountType: val._tradeAccountType
      }
      let res = await api1.getNewBalance(params)
      this.formLoading = false
      if (res && res.code === 200) {
        this.cashList = res.data && res.data.map(item => {
          return {
            ...item,
            amount: Number(item.awb),
            maxAmount: Number(item.finalAWB)
          }
        })
        this.totalAmount = this.cashList.find(item => item.currency === this.outCurrency).maxAmount || 0
          this.placeholderText = `${this.$t('fundTransfer.placeholderAmount')},${this.$t('fundTransfer.maxText')}${this.outCurrency} ${this.Util.formatCurrency(this.totalAmount)}`
      }
    }
  }
}
</script>
<style lang="scss">
.fund-transfer {
  height: min-content;
  .error-dialog{
    .footer-box{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .el-dialog__header{
      text-align: center;
      font-weight: 600;
    }
  }
  .readonly-input {
    position: relative;
    .help-box {
      padding-left: 6px;
      // position: absolute;
      // top: -21px;
      // right: 0;
      // left: 304px;
    }
  }
}
.fund-transfer-form {
  background: #fff;
  padding: 0px 30px;
  .checkboxTips {
    // margin: 20px auto;
    // padding-left: 2%;
    .el-checkbox__input {
      vertical-align: middle;
      margin-right: 8px;
    }
    .el-checkbox__label {
      font-size: 14px !important;
      color: #333;
    }
  }
  .depositReciepTips {
    width: 96%;
    background: #f4f4f4;
    border-left: 3px solid #fec000;
    padding: 2%;
    margin-top: 10px;
    p {
      margin: 0;
      line-height: 20px;
    }
    .ReciepTipsTitle {
      font-size: 20px;
      font-weight: 600;
    }
  }
  .transfer-tip {
    color: #666;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .el-range-editor.el-input__inner {
    width: 100%;
  }
  .el-input__inner {
    font-family: Muli-Bold;
    font-size: 14px;
    color: #24282d;
    letter-spacing: 0;
    height: 45px;
    height: 45px;
    // border-color: #fec000;
  }
  input::-webkit-input-placeholder {
    font-family: Arial, Helvetica, sans-serif;
  }

  .el-select {
    width: 100%;
  }

  .el-select .el-input .el-select__caret {
    color: #fec000;
  }
  .readonly-input .el-input.is-disabled .el-input__inner {
    background: #e2e2e2;
    color: #24282d;
  }

  .el-input-group__prepend {
    background: #f3f4f6;
    font-weight: bold;
    color: #24282d;
  }

  .el-button {
    margin-top: 20px;
    width: 50%;
    color: #192b57;
    font-weight: bold;
    height: 56px;
    border-color: #ffe080;
    background-color: #fecd33;
    max-width: 250px;
  }

  .el-button--primary span {
    font-family: Muli-Bold;
    font-size: 14px;
    color: #193060;
    letter-spacing: 0.17px;
  }

  .el-button--primary:hover,
  .el-button--primary:focus {
    border-color: #fecd33;
    background-color: #fecd33;
    color: #192b57;
  }

  .input_aomut .el-input__inner {
    padding-left: 40px;
  }

  .h1-title {
    border-bottom: 4px solid #e2e2e2;
    margin: 0 0 20px;
    padding: 20px 0;
    font-weight: bold;
    color: #182a54;
    font-size: 18px;
  }

  .money-icon {
    height: 45px;
    line-height: 45px;
    padding: 0px 5px;
    color: #24282d;
    font-weight: bold;
  }

  .currency-input {
    width: 120px;
  }
  .line-space-input {
    margin-top: 15px !important;
  }
}
@media (max-width: 768px) {
  .layout-container .container .view {
    max-width: 100%;
    padding: 0 !important;
    margin: 0 !important;
  }
  .m0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .p0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .transfer-records {
    margin-top: 20px;
  }
}
</style>
<style lang="scss" scoped>
.transfer-help-dialog {
  /deep/.el-dialog__body {
    padding: 0 30px 30px !important;
  }
}
.liquidation-box {
  color: #f13e3d;
  font-size: 14px;
  padding: 20px 0;
}
.checkboxTips {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px 0;
  /deep/ .el-checkbox__input {
    vertical-align: middle;
    margin-right: 8px;
  }
  /deep/ .el-checkbox__label {
    font-size: 14px !important;
    color: #333;
    width: 100% !important;
    white-space: normal;
  }
}
.btn-box-one {
  padding-top: 30px;
  .top {
    margin-bottom: 0;
  }
}
.btn-box {
  font-size: 14px;
  font-weight: 600;
  color: #193060;
  line-height: 20px;
  width: 120px;
  margin: auto;
  text-align: center;

  .top {
    background: #fec000;
    border-radius: 5px;
    padding: 15px 0;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .bottom {
    border-radius: 5px;
    border: 1px solid #193060;
    padding: 15px 0;
    cursor: pointer;
  }
}
</style>
